<div class="timestamp-row">
  <ul class="timestamp-row__timeline">
    <li class="timestamp-row__timeline__marker"
      *ngFor="let marker of markers; let first = first; let last = last"
      [ngClass]="{ 'inner': !first && !last, 'first': first, 'last': last }">
      <span class="timestamp-row__timeline__marker__time">{{ marker | date: 'MMM d, h:mm a' }}</span>
    </li>
  </ul>
</div>